document.documentElement.classList.remove('no-js');

const body = document.body;
const drawer = document.querySelector('[data-mobile-drawer]');
const searchPanel = document.querySelector('[data-search-panel]');

function setDrawer(open) {
  if (!drawer) return;
  drawer.classList.toggle('is-open', open);
  drawer.setAttribute('aria-hidden', String(!open));
  body.classList.toggle('menu-open', open);
}

document.addEventListener('click', (event) => {
  const menuOpen = event.target.closest('[data-menu-open]');
  const menuClose = event.target.closest('[data-menu-close]');
  const searchOpen = event.target.closest('[data-search-open]');
  const searchClose = event.target.closest('[data-search-close]');
  if (menuOpen) setDrawer(true);
  if (menuClose) setDrawer(false);
  if (searchOpen && searchPanel) {
    searchPanel.classList.add('is-open');
    searchPanel.querySelector('input')?.focus();
  }
  if (searchClose && searchPanel) searchPanel.classList.remove('is-open');
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    setDrawer(false);
    searchPanel?.classList.remove('is-open');
  }
});

/* Siden subtle scroll motion */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initMotion = () => {
    if (reduceMotion.matches) return;

    const targets = document.querySelectorAll(
      '.section-heading, .category-card, .product-card, .story__media, .story__content, .benefit, .newsletter > .page-width'
    );

    targets.forEach((element, index) => {
      element.classList.add('siden-motion-item');
      element.style.setProperty('--siden-motion-delay', String((index % 4) * 70) + 'ms');
    });

    if (!('IntersectionObserver' in window)) {
      targets.forEach((element) => element.classList.add('siden-motion-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('siden-motion-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    targets.forEach((element) => observer.observe(element));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMotion, { once: true });
  } else {
    initMotion();
  }
})();
